import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import OpalItemPicker from '../../../opal/OpalItemPicker'

function DenaliOpReportFilterPicker ({ value, onChange, configuration, isLoading, filterGroupTag }) {
  const hasFilters = useMemo(() => configuration?.filters?.length > 0, [configuration])
  const options = useMemo(() => {
    const options = configuration?.filters?.filter(f => !filterGroupTag || filterGroupTag === f.filterGroupTag).map(f => ({
      label: f.name,
      value: f.firmReportFilterId
    })) || []
    if (options.length) {
      options.unshift({ label: configuration.report.description, value: null })
    }
    return options
  }, [configuration, filterGroupTag])
  const handleSelect = useCallback((option) => {
    onChange?.(option.value)
  }, [onChange])

  if (isLoading) {
    return null
  }

  if (!hasFilters) {
    return null
  }

  return (
    <OpalItemPicker
      className='p-xs'
      value={value}
      onSelect={handleSelect}
      options={options}
      placeholder={configuration.report.description}
    />
  )
}

DenaliOpReportFilterPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  configuration: PropTypes.object,
  isLoading: PropTypes.bool,
  filterGroupTag: PropTypes.string
}

export default DenaliOpReportFilterPicker
